<template>
  
  <div>
    <v-row class="py-12 px-5 fill-height">
      <v-col cols="12" class="py-12 fill-height text-center">
        <h1>404</h1>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>